<template>
    <div class="login-body">
        <Toast />
        <div class="login-wrapper">
            <div class="login-panel">
                <img class="login-logo" src="@/assets/img/new-logo.svg" alt="diamond-layout" />
                <h3>Восстановление пароля!</h3>
                <i class="pi p-my-3 pi-check-circle" style="fontsize: 2rem"></i>
                <p class="p-my-2">На ваш E-mail отправлено письмо с инструкцией по восстановлению пароля.</p>
                <p class="p-mb-6">По всем возникшим вопросам Вы можете обратиться в службу поддержки НИИОЗМ по телефону: <a href="tel:84954171209" target="_blank" class="telColor">8 (495) 417-12-09 доб. 313/349</a></p>
                <div class="p-mb-0 p-mr-auto">
                    <Button class="p-mr-2 p-mb-0 p-button-text" @click="$router.push('/login')" label="Назад" />
                </div>
            </div>
            <LoginImage />
        </div>
    </div>
</template>

<script>
import LoginImage from '@/components/loginComponents/LoginImage';

export default {
    name: 'PassRecoveryConfirm',
    components: { LoginImage },
};
</script>

<style lang="scss" scoped>
.login-body .login-wrapper .login-panel p {
    font-weight: 400;
    color: black;
}

.login-logo {
    height: 122px;
    width: 104px;
}

.telColor {
    color: #606060 !important;
}
</style>
